function concat(pathArray) {
  return pathArray.join('/')
}

export let moduleNames = {
  meterReading: 'meterReading',
  meterReading_step1: concat(['meterReading', 'step1']),
  meterReading_step2: concat(['meterReading', 'step2']),
  meterReading_step3: concat(['meterReading', 'step3']),
  meterReading_step4: concat(['meterReading', 'step4']),
  consumption: 'consumption',
  consumption_step1: concat(['consumption', 'step1']),
  consumption_step2: concat(['consumption', 'step2']),
  appointment: 'appointment',
  appointment_step1: concat(['appointment', 'step1']),
  appointment_step2: concat(['appointment', 'step2']),
  appointment_step3: concat(['appointment', 'step3']),
  unsubscribe: 'unsubscribe',
  unsubscribe_step1: concat(['unsubscribe', 'step1']),
  unsubscribe_step2: concat(['unsubscribe', 'step2']),
  monthOfStatement: 'monthOfStatement',
  monthOfStatement_step1: concat(['monthOfStatement', 'step1']),
  monthOfStatement_step2: concat(['monthOfStatement', 'step2'])
}

export let mutationTypes = {
  root: {
    SET_API_ERRORS: 'SET_API_ERROR',
    CLEAR_API_ERRORS: 'CLEAR_API_ERRORS'
  },
  meterReading: {
    RESET_STATE: 'RESET_STATE',
    RESET_STATE_ROOT: concat([moduleNames.meterReading, 'RESET_STATE']),
    ACTIVATE_STEP: 'ACTIVATE_STEP',
    ACTIVATE_STEP_ROOT: concat([moduleNames.meterReading, 'ACTIVATE_STEP']),
    UNACTIVATE_STEP: 'UNACTIVATE_STEP',
    UNACTIVATE_STEP_ROOT: concat([moduleNames.meterReading, 'UNACTIVATE_STEP']),
    step1: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.meterReading_step1, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.meterReading_step1, 'REGISTER_FORM_DATAS'])
    },
    step2: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.meterReading_step2, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.meterReading_step2, 'REGISTER_FORM_DATAS'])
    },
    step3: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.meterReading_step3, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.meterReading_step3, 'REGISTER_FORM_DATAS']),
      MANAGE_USER_COORDINATES_CHANGES: 'MANAGE_USER_COORDINATES_CHANGES',
      MANAGE_USER_COORDINATES_CHANGES_ROOT: concat([moduleNames.meterReading_step3, 'MANAGE_USER_COORDINATES_CHANGES'])
    },
    step4: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.meterReading_step4, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.meterReading_step4, 'REGISTER_FORM_DATAS'])
    }
  },
  consumption: {
    RESET_STATE: 'RESET_STATE',
    RESET_STATE_ROOT: concat([moduleNames.consumption, 'RESET_STATE']),
    ACTIVATE_STEP: 'ACTIVATE_STEP',
    ACTIVATE_STEP_ROOT: concat([moduleNames.consumption, 'ACTIVATE_STEP']),
    UNACTIVATE_STEP: 'UNACTIVATE_STEP',
    UNACTIVATE_STEP_ROOT: concat([moduleNames.consumption, 'UNACTIVATE_STEP']),
    step1: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.consumption_step1, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.consumption_step1, 'REGISTER_FORM_DATAS'])
    },
    step2: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.consumption_step2, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.consumption_step2, 'REGISTER_FORM_DATAS'])
    }
  },
  appointment: {
    RESET_STATE: 'RESET_STATE',
    RESET_STATE_ROOT: concat([moduleNames.appointment, 'RESET_STATE']),
    ACTIVATE_STEP: 'ACTIVATE_STEP',
    ACTIVATE_STEP_ROOT: concat([moduleNames.appointment, 'ACTIVATE_STEP']),
    UNACTIVATE_STEP: 'UNACTIVATE_STEP',
    UNACTIVATE_STEP_ROOT: concat([moduleNames.appointment, 'UNACTIVATE_STEP']),
    step1: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.appointment_step1, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.appointment_step1, 'REGISTER_FORM_DATAS'])
    },
    step2: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.appointment_step2, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.appointment_step2, 'REGISTER_FORM_DATAS'])
    },
    step3: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.appointment_step3, 'RESET_STATE']),
      REGISTER_APPOINTMENT_RESPONSE: 'REGISTER_APPOINTMENT_RESPONSE',
      REGISTER_APPOINTMENT_RESPONSE_ROOT: concat([moduleNames.appointment_step3, 'REGISTER_APPOINTMENT_RESPONSE'])
    }
  },
  unsubscribe: {
    RESET_STATE: 'RESET_STATE',
    RESET_STATE_ROOT: concat([moduleNames.unsubscribe, 'RESET_STATE']),
    ACTIVATE_STEP: 'ACTIVATE_STEP',
    ACTIVATE_STEP_ROOT: concat([moduleNames.unsubscribe, 'ACTIVATE_STEP']),
    UNACTIVATE_STEP: 'UNACTIVATE_STEP',
    UNACTIVATE_STEP_ROOT: concat([moduleNames.unsubscribe, 'UNACTIVATE_STEP']),
    step1: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.unsubscribe_step1, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.unsubscribe_step1, 'REGISTER_FORM_DATAS'])
    },
    step2: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.unsubscribe_step2, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.unsubscribe_step2, 'REGISTER_FORM_DATAS'])
    }
  },
  monthOfStatement: {
    RESET_STATE: 'RESET_STATE',
    RESET_STATE_ROOT: concat([moduleNames.monthOfStatement, 'RESET_STATE']),
    ACTIVATE_STEP: 'ACTIVATE_STEP',
    ACTIVATE_STEP_ROOT: concat([moduleNames.monthOfStatement, 'ACTIVATE_STEP']),
    UNACTIVATE_STEP: 'UNACTIVATE_STEP',
    UNACTIVATE_STEP_ROOT: concat([moduleNames.monthOfStatement, 'UNACTIVATE_STEP']),
    step1: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.monthOfStatement_step1, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.monthOfStatement_step1, 'REGISTER_FORM_DATAS'])
    },
    step2: {
      RESET_STATE: 'RESET_STATE',
      RESET_STATE_ROOT: concat([moduleNames.monthOfStatement_step2, 'RESET_STATE']),
      REGISTER_FORM_DATAS: 'REGISTER_FORM_DATAS',
      REGISTER_FORM_DATAS_ROOT: concat([moduleNames.monthOfStatement_step2, 'REGISTER_FORM_DATAS'])
    }
  }
}

export let actionTypes = {
  root: {},
  meterReading: {
    RESET_FORM: 'RESET_FORM',
    RESET_FORM_ROOT: concat([moduleNames.meterReading, 'RESET_FORM']),
    step1: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.meterReading_step1, 'COMPLETE_STEP'])
    },
    step2: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.meterReading_step2, 'COMPLETE_STEP'])
    },
    step3: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.meterReading_step3, 'COMPLETE_STEP']),
      RESET_STEP: 'RESET_STEP',
      RESET_STEP_ROOT: concat([moduleNames.meterReading_step3, 'RESET_STEP'])
    }
  },
  consumption: {
    RESET_FORM: 'RESET_FORM',
    RESET_FORM_ROOT: concat([moduleNames.consumption, 'RESET_FORM']),
    step1: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.consumption_step1, 'COMPLETE_STEP'])
    },
    step2: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.consumption_step2, 'COMPLETE_STEP'])
    }
  },
  appointment: {
    RESET_FORM: 'RESET_FORM',
    RESET_FORM_ROOT: concat([moduleNames.appointment, 'RESET_FORM']),
    step1: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.appointment_step1, 'COMPLETE_STEP'])
    },
    step2: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.appointment_step2, 'COMPLETE_STEP'])
    },
    step3: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.appointment_step3, 'COMPLETE_STEP']),
      RESET_STEP: 'RESET_STEP',
      RESET_STEP_ROOT: concat([moduleNames.appointment_step3, 'RESET_STEP'])
    }
  },
  unsubscribe: {
    RESET_FORM: 'RESET_FORM',
    RESET_FORM_ROOT: concat([moduleNames.unsubscribe, 'RESET_FORM']),
    step1: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.unsubscribe, 'COMPLETE_STEP'])
    },
    step2: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.unsubscribe, 'COMPLETE_STEP'])
    }
  },
  monthOfStatement: {
    RESET_FORM: 'RESET_FORM',
    RESET_FORM_ROOT: concat([moduleNames.monthOfStatement, 'RESET_FORM']),
    step1: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.monthOfStatement, 'COMPLETE_STEP'])
    },
    step2: {
      COMPLETE_STEP: 'COMPLETE_STEP',
      COMPLETE_STEP_ROOT: concat([moduleNames.monthOfStatement, 'COMPLETE_STEP'])
    }
  }
}
